export default __webpack_public_path__ + "static/media/Windfarm tower_V.3.17dc830e.png";